import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/phone.svg'
import _imports_1 from '@/assets/mail.svg'


_pushScopeId("data-v-75e194e2")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "title" }, "Need more help? We're here!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Our expert customer service team is ready to help you with any questions or concerns you may have. Real time help is available "),
    /*#__PURE__*/_createElementVNode("strong", null, "Monday through Friday 9AM - 6PM EST")
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "contact-info" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
      /*#__PURE__*/_createElementVNode("a", { href: "tel:888-388-2502" }, "888-388-2502")
    ]),
    /*#__PURE__*/_createElementVNode("div", { id: "spacer" }),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@sheetlabels.com" }, "support@sheetlabels.com")
    ])
  ])
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("h1", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            style: {"width":"25px","height":"25px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, {
              propId: 'print-close',
              fillColor: '#f7f9fc'
            })
          ])
        ]),
        _hoisted_3
      ], 2)
    ], 2)
  ]))
}